import { ChevronLeft } from "lucide-react";
import Footer from "./Footer";
import NavBar from "./NavBar";
import { useNavigate } from "react-router-dom";
import CardPlanosMensaisResidenciais from "../components/Cards/CardPlanosMensaisResidenciais";
import CardPlanosTrimestraisResidenciais from "../components/Cards/CardPlanosTrimestraisResidenciais";
import { motion } from "framer-motion";

export default function VariedadeplanosResidenciais() {
  const navigate = useNavigate();

  const propsCardPlanoResidenciaisMensais = {
    descricao: "Planos Mensais",
  };

  const propsCardPlanosResidenciaisTrimestrais = {
    descricao: "Planos Trimestrais",
  };

  return (
    <div className="flex h-screen justify-between flex-col font-questrial text-white">
      {/* Navbar */}
      <div className="bg-blue-500 h-[34%] z-10 sticky top-0">
        <NavBar />
      </div>

      {/* Conteúdo animado */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        className="z-0 lg:z-20 lg:h-[50px] lg:w-[700px] md:w-[650px] sm:w-[540px] lg:-mt-[100px] 
          flex flex-col sm:items-center mb-4 sm:flex-row justify-around items-center 
          lg:items-center space-y-4 sm:space-y-0 sm:space-x-4 container mx-auto mt-8"
      >
        {/* Botão Voltar */}
        <motion.button
          whileHover={{ x: -5 }}
          whileTap={{ scale: 0.95 }}
          className="group flex absolute left-4 bottom-[76%]"
          onClick={() => navigate(-1)}
        >
          <div className="flex md:flex lg:hidden">
            <ChevronLeft className="text-black" />
            <span className="text-sm ml-1 text-black">Voltar</span>
          </div>
        </motion.button>

        {/* Card Mensal */}
        <motion.button
          onClick={() => navigate("/planosresidenciais")}
          className="w-[60%] sm:w-[48%] lg:w-[40%]"
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.1 }}
          whileHover={{ scale: 1.03 }}
          whileTap={{ scale: 0.97 }}
        >
          <CardPlanosMensaisResidenciais {...propsCardPlanoResidenciaisMensais} />
        </motion.button>

        {/* Card Trimestral */}
        <motion.button
          onClick={() => navigate("/planosresidenciaistrimestrais")}
          className="w-[60%] sm:w-[48%] lg:w-[40%]"
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.2 }}
          whileHover={{ scale: 1.03 }}
          whileTap={{ scale: 0.97 }}
        >
          <CardPlanosTrimestraisResidenciais {...propsCardPlanosResidenciaisTrimestrais} />
        </motion.button>
      </motion.div>

      {/* Footer */}
      <div className="bg-blue-500 p-4 pb-2 font-extralight">
        <Footer />
      </div>
    </div>
  );
}
